import React from 'react';
import { useGetPhenomenonTypesQuery } from 'Services/api/phenomenonTypesApi';
import { PhenomenonType } from 'Features/Settings/Settings.Common/Common.ObservingPrograms/CreateProgram/types';
import { SelectObjectById } from './SelectObjectById';
import { CommonSelectProps } from './types';

function SelectPhenomenonTypeDefault({
  selected,
  onChangeValue,
  firstOptionLabel = '',
  ...selectProps
}: CommonSelectProps) {
  const { data: types, isLoading, isFetching } = useGetPhenomenonTypesQuery(undefined);
  const optionLabel = (type: PhenomenonType) => type.name;

  return (
    <SelectObjectById
      {...selectProps}
      name="phenomenonType"
      data={types}
      selected={selected}
      onChangeValue={onChangeValue}
      isLoading={isLoading || isFetching}
      firstOptionLabel={firstOptionLabel || 'ВСЕ'}
      optionLabel={optionLabel}
    />
  );
}

/**
 * Компонент выбора phenomenonType с выгрузкой массива phenomenonTypes с сервера
 * @param selected айди phenomenonType
 * @param onChangeValue (phenomenonTypeId: number, phenomenonType: object) => void
 */
export const SelectPhenomenonType = React.memo(SelectPhenomenonTypeDefault);
SelectPhenomenonType.displayName = 'SelectPhenomenonType';
